var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.75C3 2.33579 3.33579 2 3.75 2H20.25C20.6642 2 21 2.33579 21 2.75C21 3.16421 20.6642 3.5 20.25 3.5H19V6.3582C19 7.63687 18.3485 8.82743 17.2715 9.51672L13.3913 12L17.2715 14.4833C18.3485 15.1726 19 16.3631 19 17.6418V20.5H20.25C20.6642 20.5 21 20.8358 21 21.25C21 21.6642 20.6642 22 20.25 22H3.75C3.33579 22 3 21.6642 3 21.25C3 20.8358 3.33579 20.5 3.75 20.5H5V17.6418C5 16.3631 5.65155 15.1725 6.72856 14.4833L10.6087 12L6.72855 9.51672C5.65155 8.82744 5 7.63689 5 6.3582V3.5H3.75C3.33579 3.5 3 3.16421 3 2.75ZM6.5 3.5V6.3582C6.5 7.12541 6.89093 7.83974 7.53713 8.25332C7.53713 8.25332 7.53713 8.25332 7.53713 8.25332L12 11.1096L16.4629 8.25332C17.1091 7.83975 17.5 7.12543 17.5 6.3582V3.5H6.5ZM12 12.8904L7.53713 15.7467C6.89094 16.1602 6.5 16.8745 6.5 17.6418V20.5H17.5V17.6418C17.5 16.8745 17.1091 16.1602 16.4629 15.7467L12 12.8904Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.7076faee871332246524d679cc2169ea.svg";
export { ForwardRef as ReactComponent };